import { StorageContainer, CreateStorageContainerInput } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface CreateStorageContainerMutation {
  createStorageContainer: StorageContainer
}

export interface CreateStorageContainerVariables {
  input: CreateStorageContainerInput
}

export const GQL_MUTATION_CREATE_STORAGE_CONTAINER = gql`
  mutation createStorageContainer($input: CreateStorageContainerInput!) {
    createStorageContainer(input: $input) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at
      displayName
    }
  }
`

export function useCreateStorageContainer () {
  return useMutation<CreateStorageContainerMutation, CreateStorageContainerVariables>(
    GQL_MUTATION_CREATE_STORAGE_CONTAINER
  )
}
